import { Injectable } from '@angular/core';
import { ContentModel } from '../common/models/content.model';
import { PageJsonResults } from '../common/services/page/page-data.viewmodel';
import { PageService } from '../common/services/page/page.service';
import { map, Observable, of } from 'rxjs';
import { HeaderResponse } from './header.viewmodel';
import { ExperienceFragmentRequest } from '../common/services/page/page-component-data.viewmodel';
import { SettingsService } from '../common/services/settings.service';
import { CACHE_KEYS } from '../common/constants/cache-keys';
import { LoginResults, LoginSelections } from '../login/login.viewmodel';
import { BaseService } from '../common/services/base.service';
import { CacheService } from '../common/services/cache.service';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  constructor(private pageService: PageService, private settingsService: SettingsService, private baseService: BaseService,
    private cacheService: CacheService
  ) { }

  getHeader(): Observable<HeaderResponse> {
    let url: string = `/v1/lpmi/portal/getHeader`;
    let loginData: LoginResults = this.cacheService.getFromCache(CACHE_KEYS.LOGIN.LOGIN_DATA);
    let loginSelections: LoginSelections = this.cacheService.getFromCache(CACHE_KEYS.LOGIN.LOGIN_SELECTIONS);
    let region = loginSelections?.region ;
    let businessOp = loginSelections?.selectedBusinessLabel?.key;
    let businessUnit = (businessOp === 'HQ/Admin' || businessOp === 'admin') ? 'admin' : businessOp;
    let countryCode = loginSelections?.market;
    let language = this.pageService.getPreferredLanguage().languageCode;
    let request = new ExperienceFragmentRequest();
    request.componentType = '';
    request.userDetails = this.pageService.getUserDetails();
    request.experienceFragments = [ `${this.settingsService.NUC_PAGE_PATH_PREFIX}/${region}/${countryCode}/${language}/${businessUnit}/header`
    ];

    // return this.getHeaderMock().pipe(
    return this.baseService.post<HeaderResponse>(`${url}`, request, 'API').pipe(
      map((res: HeaderResponse) => {
        if (res?.pageComponents?.length) {
          const header = res.pageComponents.find((component) => component.componentType === 'header')?.data?.[0];
          const appLinks = res.pageComponents.find((component) => component.componentType === 'applinks-reference')?.data?.[0];

          return {
            ...res,
            results: {
              ...res.results,
              header: header ?? res.results?.header,
              labels: header?.labels ?? res.results?.labels,
              appLinks: appLinks ? { ...res.results?.appLinks, ...appLinks } : res.results?.appLinks,
            },
          };
        }

        return res;
      })
    );
  }

}
